import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2';
import './plugins/vuetify';
import App from './App.vue';
import aws_exports from './aws-exports';

import ConcussionClinic from './components/ConcussionClinic.vue';
import ConcussionExam from './components/ConcussionExam.vue';
import DementiaQualityCareMetrics from './components/DementiaQualityCareMetrics.vue';
import Authentication from './components/Authentication.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Amplify.configure(aws_exports);

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(VueRouter);
Vue.use(Loading);
Vue.component('loading', Loading);

class SharedData {
  public signedIn: boolean = false;
}

new Vue({
  data: new SharedData(),
  render: (h) => h(App),
  router: new VueRouter({
    routes: [
      { path: '/', component: ConcussionClinic },
      { path: '/concussion-clinic', component: ConcussionClinic },
      { path: '/concussion-exam', component: ConcussionExam },
      { path: '/dementia-quality-care-metrics', component: DementiaQualityCareMetrics },
      { path: '/auth', component: Authentication, name: 'auth' },
    ],
  }),
}).$mount('#app');

